import React, { Component } from "react";
import { Table, Button, Row, Col } from "antd";
import axios from "axios";
import PrintModal from '../components/PrintModal';
import moment from "moment-timezone"; // VALIDAR DATAS
import numeral from "numeral";
import "./Relatorios.css";

const { Column } = Table;

class PedidosPrintModal extends Component {
    state = {
        listaRegistros: [],
        visualizar: false,
        carregando: false,
    }

    componentDidUpdate(propsAnte, stateAnte) {
        if (!stateAnte.visualizar && this.state.visualizar) {
            this.getListaRegistros();
        }
    }

    getListaRegistros = () => {
        this.setState({ carregando: true, listaRegistros: [] });

        const { buscaDataIni, buscaDataFim, buscaControle, buscaPessoa, buscaMunicipio,
            buscaUsuario, buscaTipo, buscaOrdem } = this.props.filtros;

        let ven_dt_venda_ini = '';
        if ((buscaDataIni) && (buscaDataIni !== undefined)) {
            ven_dt_venda_ini = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
        }
        let ven_dt_venda_fim = '';
        if ((buscaDataFim) && (buscaDataFim !== undefined)) {
            ven_dt_venda_fim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
        }

        axios
            .get('/vendas', {
                params: {
                    numero: buscaControle,
                    campoOrdem: buscaOrdem.campo,
                    tipoOrdem: buscaOrdem.ordem,
                    numero: buscaControle,
                    codCliente: buscaPessoa.key,
                    cidade: buscaMunicipio.key,
                    usuario: buscaUsuario.key,
                    tipoVenda: buscaTipo.key,
                    ven_dt_venda_ini,
                    ven_dt_venda_fim,
                    print: 1
                }
            })
            .then(response => {
                this.setState({
                    listaRegistros: response.data.consulta,
                    carregando: false,
                });
            })
            .catch(erro => {
                console.warn(erro);
                this.setState({
                    carregando: false,
                });
            });
    };

    onCancelar = () => {
        this.setState({
            visualizar: false
        })
    }

    onVisualizar = () => {
        this.setState({
            visualizar: true
        })
    }

    renderValor = (ven_vlr_total, registro) => {
        return (
            <span> {numeral(parseFloat(ven_vlr_total)).format('0,000.00')} </span>
        );
    };

    renderData = (data) => {
        if (data) {
            const dataMoment = moment(data);
            return (
                <span>
                    {dataMoment.format('DD/MM/YYYY HH:mm')}
                </span>
            )
        } else {
            <span></span>
        }
    }

    renderUsuario = (usu_nome) => {
        return (
            <span>{usu_nome.substring(0, 7)}</span>
        );
    };



    render() {
        const { listaRegistros, carregando, visualizar } = this.state;
        return (
            <span>
                <Button onClick={this.onVisualizar}>
                    Impressão
                </Button>

                <PrintModal
                    visible={visualizar}
                    onCancel={this.onCancelar}
                >
                    <div >
                        <div className="titulo">
                            Relatório de Pedidos
                        </div>

                        <Row>
                            <Col xs={24} style={{ marginTop: 14, textAlign: "center" }} >
                                <span style={{ fontWeight: "bold" }}>Total Pedidos: </span>
                                <span>R$ {this.renderValor(this.props.vlrTotalPed)}</span>

                                <span style={{ fontWeight: "bold", marginLeft: 30 }}>Qtde Pedidos: </span>
                                <span>{this.props.qtdePed}</span>

                                <span style={{ fontWeight: "bold", marginLeft: 30 }}>Total Orçamentos: </span>
                                <span>R$ {this.renderValor(this.props.vlrTotalOrc)}</span>

                                <span style={{ fontWeight: "bold", marginLeft: 30 }}>Qtde Orçamentos: </span>
                                <span>{this.props.qtdeOrc}</span>
                            </Col>
                        </Row>

                        <Table
                            pagination={false}
                            dataSource={listaRegistros}
                            className="tabela"
                            loading={{
                                spinning: carregando,
                                tip: 'Carregando. Aguarde...',
                                size: "large"
                            }}
                        >
                            <Column
                                key="ven_numero"
                                dataIndex="ven_numero"
                                title="Nº"
                                width={"5%"}
                                align="center"
                                className="listaCadastro"
                            />
                            <Column
                                key="ven_dt_venda"
                                dataIndex="ven_dt_venda"
                                title="Emissão"
                                render={this.renderData}
                                width={"12%"}
                                align="center"
                                className="listaCadastro"
                            />
                            <Column
                                key="ven_dt_recebido"
                                dataIndex="ven_dt_recebido"
                                title="Recebido"
                                render={this.renderData}
                                width={"12%"}
                                align="center"
                                className="listaCadastro"
                            />
                            <Column
                                key="ven_dt_enviado"
                                dataIndex="ven_dt_enviado"
                                title="Sincronizado"
                                render={this.renderData}
                                width={"12%"}
                                align="center"
                                className="listaCadastro"
                            />
                            <Column
                                key="pes_nome"
                                dataIndex="pes_nome"
                                title="Cliente"
                                width={"10%"}
                                align="left"
                                className="listaCadastro"
                            />
                            <Column
                                key="ven_tipo_venda"
                                dataIndex="ven_tipo_venda"
                                title="Tipo"
                                width={"5%"}
                                align="center"
                                className="listaCadastro"
                            />
                            <Column
                                key="ven_vlr_total"
                                dataIndex="ven_vlr_total"
                                title="Valor"
                                render={this.renderValor}
                                width={"10%"}
                                align="right"
                                className="listaCadastro"
                            />
                            <Column
                                key="usu_nome"
                                dataIndex="usu_nome"
                                title="Vendedor"
                                width={"10%"}
                                align="center"
                                className="listaCadastro"
                                render={this.renderUsuario}
                            />
                        </Table>
                    </div>

                </PrintModal>
            </span>
        );
    }
}

export default PedidosPrintModal;



// WEBPACK FOOTER //
// ./src/relatorios/PedidosPrintModal.js